import React from "react";

import * as S from "./styles";

import computer from "../../../../assets/images/computer.png";

const Intro: React.FC = () => (
  <S.Container>
    <S.Img src={computer} alt="computer's image" />
    <S.SubTitle>CONTABILIDADE PARA DESENVOLVEDORES</S.SubTitle>
    <S.Title>
      Concentre-se no código, <br /> nós cuidamos dos números
      <br /> para você
    </S.Title>
    <S.Button to="/">Entrar na minha conta</S.Button>
    <S.RegisterLink to="/registrar">
      Não possui conta? <span>Cadastre-se com e-mail</span>
    </S.RegisterLink>
    <S.TermsLink to="/termos-de-uso">Termos de privacidade</S.TermsLink>
  </S.Container>
);
export default Intro;
